import * as React from 'react';
import { Link } from 'gatsby';
import Helmet from 'react-helmet';
import config from '../config';
import * as main from './MainLayout.css';

export const MainLayout: React.FunctionComponent<any> = props => {
  const twitter = config.twitter ? config.twitter.split('https://twitter.com/')[0] : "";
  return (
    <div className={main.body}>
      <Helmet>
        <title>{config.title}</title>
        <meta name="theme-color" content="#091F27" />
        <meta name="apple-mobile-web-app-capable" content="yes" />
        <meta name="apple-mobile-web-app-status-bar-style" content="black-translucent" />
        <meta name="viewport" content="width=device-width, initial-scale=1, maximum-scale=1" />
        <meta property="article:publisher" content={config.facebook} />
        <meta property="og:site_name" content={config.title} />
        <meta property="og:type" content="website" />
        <meta property="og:title" content={config.title} />
        <meta property="og:description" content={config.description} />
        <meta property="og:url" content={config.siteUrl} />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content={config.title} />
        <meta name="twitter:description" content={config.description} />
        <meta name="twitter:url" content={config.siteUrl} />
        <meta name="twitter:site" content={`@${twitter}`} />
        <style>
          {css}
        </style>
      </Helmet>
      <div className={main.topline}></div>
      <div className={main.logo}>
        <Link to="/"><img src="https://nezaboodka.com/img/logo-1000.svg"/> <span className={main.site}>Blog</span></Link>
      </div>
      <div className={main.menu}>
        <Link to="/" className={main.menuItem + " " + main.menuItemCurrent}><img src="https://nezaboodka.com/img/home.svg"/></Link>
        <a href="https://nezaboodka.com" className={main.menuItem}>Company</a>
      </div>
      {props.children}
      <div className={main.footer}>
        Copyright (С) 2011-2026<br/>
        Nezaboodka Software LLC. All rights reserved.<br/>
        <Link to="mailto:contact@nezaboodka.com?subject=Hi">contact@nezaboodka.com</Link>
      </div>
      <img src="https://mc.yandex.ru/watch/85779066" style={{position: 'absolute', left: '-9999px'}} alt="" />
    </div>
  );
};

const css = `
/*! normalize.css v6.0.0 | MIT License | github.com/necolas/normalize.css */

/*
 * 1. Correct the line height in all browsers.
 * 2. Prevent adjustments of font size after orientation changes in
 *   IE on Windows Phone and in iOS.
 */

html
{
  line-height: 1.15; /* 1 */
  -ms-text-size-adjust: 100%; /* 2 */
  -webkit-text-size-adjust: 100%; /* 2 */
  font-family: Arial, Tahoma, sans-serif;
  background-color: #091F27;
  color: white;
  text-shadow: 0 0 1px black;
}

body
{
  margin: 0;
  padding: 0;
  overflow-x: hidden;
  overflow-y: scroll;
  text-shadow: 0 0 1px black;
  background-color: #091F27;
  color: #f0f0f0;
}

/*
 * Add the correct display in IE 9-.
 */

article, aside, footer, header, nav, section
{
  display: block;
}

/*
 * Correct the font size and margin on "h1" elements within "section" and
 * "article" contexts in Chrome, Firefox, and Safari.
 */

h1
{
  font-size: 2em;
  margin: 0.67em 0;
}

/*
 * Add the correct display in IE 9-.
 * 1. Add the correct display in IE.
 */
figcaption, figure, main
{ /* 1 */
  display: block;
}

/*
 * Add the correct margin in IE 8.
 */

figure
{
  margin: 1em 40px;
}

/*
 * 1. Add the correct box sizing in Firefox.
 * 2. Show the overflow in Edge and IE.
 */

hr
{
  box-sizing: content-box; /* 1 */
  height: 0; /* 1 */
  overflow: visible; /* 2 */
}

/*
 * 1. Correct the inheritance and scaling of font size in all browsers.
 * 2. Correct the odd "em" font sizing in all browsers.
 */

pre
{
  font-family: monospace, monospace; /* 1 */
  font-size: 1em; /* 2 */
}

/*
 * 1. Remove the gray background on active links in IE 10.
 * 2. Remove gaps in links underline in iOS 8+ and Safari 8+.
 */

a
{
  background-color: transparent; /* 1 */
  -webkit-text-decoration-skip: objects; /* 2 */
  text-decoration: none;
  color: inherit;
}

/*
 * 1. Remove the bottom border in Chrome 57- and Firefox 39-.
 * 2. Add the correct text decoration in Chrome, Edge, IE, Opera, and Safari.
 */

abbr[title]
{
  border-bottom: none; /* 1 */
  text-decoration: none; /* 2 */
}

/*
 * Prevent the duplicate application of "bolder" by the next rule in Safari 6.
 */

b, strong
{
  font-weight: inherit;
}

/*
 * Add the correct font weight in Chrome, Edge, and Safari.
 */

b, strong
{
  font-weight: bolder;
}

/*
 * 1. Correct the inheritance and scaling of font size in all browsers.
 * 2. Correct the odd "em" font sizing in all browsers.
 */

code, kbd, samp
{
  font-family: monospace, monospace; /* 1 */
  font-size: 1em; /* 2 */
}

/*
 * Add the correct font style in Android 4.3-.
 */

dfn
{
  font-style: italic;
}

/*
 * Add the correct background and color in IE 9-.
 */

mark
{
  background-color: #ff0;
  color: #000;
}

/*
 * Add the correct font size in all browsers.
 */

small
{
  font-size: 80%;
}

/*
 * Prevent "sub" and "sup" elements from affecting the line height in
 * all browsers.
 */

sub, sup
{
  font-size: 75%;
  line-height: 0;
  position: relative;
  vertical-align: baseline;
}

sub
{
  bottom: -0.25em;
}

sup
{
  top: -0.5em;
}

/*
 * Add the correct display in IE 9-.
 */

audio, video
{
  display: inline-block;
}

/*
 * Add the correct display in iOS 4-7.
 */

audio:not([controls])
{
  display: none;
  height: 0;
}

/*
 * Remove the border on images inside links in IE 10-.
 */

img,
svg
{
  border-style: none;
  margin: 0;
  padding: 0;
  height: 1.15em;
  width: auto;
}

/*
 * Hide the overflow in IE.
 */

svg:not(:root)
{
  overflow: hidden;
}

/*
 * Remove the margin in Firefox and Safari.
 */

button, input, optgroup, select, textarea
{
  margin: 0;
}

/*
 * Show the overflow in IE.
 * 1. Show the overflow in Edge.
 */

button, input
{
  overflow: visible; /* 1 */
}

/*
 * Remove the inheritance of text transform in Edge, Firefox, and IE.
 * 1. Remove the inheritance of text transform in Firefox.
 */

button, select
{
  text-transform: none; /* 1 */
}

/*
 * 1. Prevent a WebKit bug where (2) destroys native "audio" and "video"
 *    controls in Android 4.
 * 2. Correct the inability to style clickable types in iOS and Safari.
 */

button, html [type="button"], /* 1 */ [type="reset"], [type="submit"]
{
  -webkit-appearance: button; /* 2 */
}

/*
 * Remove the inner border and padding in Firefox.
 */

button::-moz-focus-inner, [type="button"]::-moz-focus-inner,
[type="reset"]::-moz-focus-inner, [type="submit"]::-moz-focus-inner
{
  border-style: none;
  padding: 0;
}

/*
 * Restore the focus styles unset by the previous rule.
 */

button:-moz-focusring, [type="button"]:-moz-focusring,
[type="reset"]:-moz-focusring, [type="submit"]:-moz-focusring
{
  outline: 1px dotted ButtonText;
}

/*
 * 1. Correct the text wrapping in Edge and IE.
 * 2. Correct the color inheritance from "fieldset" elements in IE.
 * 3. Remove the padding so developers are not caught out when they zero out
 *    "fieldset" elements in all browsers.
 */

legend
{
  box-sizing: border-box; /* 1 */
  color: inherit; /* 2 */
  display: table; /* 1 */
  max-width: 100%; /* 1 */
  padding: 0; /* 3 */
  white-space: normal; /* 1 */
}

/*
 * 1. Add the correct display in IE 9-.
 * 2. Add the correct vertical alignment in Chrome, Firefox, and Opera.
 */

progress
{
  display: inline-block; /* 1 */
  vertical-align: baseline; /* 2 */
}

/*
 * Remove the default vertical scrollbar in IE.
 */

textarea
{
  overflow: auto;
}

/*
 * 1. Add the correct box sizing in IE 10-.
 * 2. Remove the padding in IE 10-.
 */

[type="checkbox"], [type="radio"]
{
  box-sizing: border-box; /* 1 */
  padding: 0; /* 2 */
}

/*
 * Correct the cursor style of increment and decrement buttons in Chrome.
 */

[type="number"]::-webkit-inner-spin-button,
[type="number"]::-webkit-outer-spin-button
{
  height: auto;
}

/*
 * 1. Correct the odd appearance in Chrome and Safari.
 * 2. Correct the outline style in Safari.
 */

[type="search"]
{
  -webkit-appearance: textfield; /* 1 */
  outline-offset: -2px; /* 2 */
}

/*
 * Remove the inner padding and cancel buttons in Chrome and Safari on macOS.
 */

[type="search"]::-webkit-search-cancel-button,
[type="search"]::-webkit-search-decoration
{
  -webkit-appearance: none;
}

/*
 * 1. Correct the inability to style clickable types in iOS and Safari.
 * 2. Change font properties to "inherit" in Safari.
 */

::-webkit-file-upload-button
{
  -webkit-appearance: button; /* 1 */
  font: inherit; /* 2 */
}

/*
 * Add the correct display in IE 9-.
 * 1. Add the correct display in Edge, IE, and Firefox.
 */

details, /* 1 */ menu
{
  display: block;
}

/*
 * Add the correct display in all browsers.
 */

summary
{
  display: list-item;
}

/*
 * Add the correct display in IE 9-.
 */

canvas
{
  display: inline-block;
}

/*
 * Add the correct display in IE.
 */

template
{
  display: none;
}

/*
 * Add the correct display in IE 10-.
 */

[hidden]
{
  display: none;
}

/*
 * WebKit scrollbars
 */

::-webkit-scrollbar
{
  width: 0.25em;
  height: 0.25em;
}

::-webkit-scrollbar-button
{
  width: calc(0.25em + 1px);
  height: calc(0.25em + 1px);

  background-color: rgba(127, 127, 127, 0.25);
}

::-webkit-scrollbar-button:vertical
{
  height: calc(0.25em + 2px);
}

::-webkit-scrollbar-button:vertical:increment
{
  border-top: 1px solid transparent;
}

::-webkit-scrollbar-button:vertical:decrement
{
  border-bottom: 1px solid transparent;
}

::-webkit-scrollbar-button:horizontal
{
  width: calc(0.25em + 2px);
}

::-webkit-scrollbar-button:horizontal:increment
{
  border-left: 1px solid transparent;
}

::-webkit-scrollbar-button:horizontal:decrement
{
  border-right: 1px solid transparent;
}

::-webkit-scrollbar-button:hover
{
  background-color: rgba(127, 127, 127, 0.6);
}

::-webkit-scrollbar-button:active
{
  background-color: rgba(127, 127, 127, 0.8);
}

::-webkit-scrollbar-thumb
{
  background-color: rgba(127, 127, 127, 0.4);
}

::-webkit-scrollbar-thumb:hover
{
  background-color: rgba(127, 127, 127, 0.6);
}

::-webkit-scrollbar-thumb:active
{
  background-color: rgba(127, 127, 127, 0.9);
}

::-webkit-scrollbar-track
{
  background-color: rgba(64, 64, 64, 0.25);
}

::-webkit-scrollbar-track:hover
{
  background-color: rgba(64, 64, 64, 0.4);
}

::-webkit-scrollbar-track:active
{
  background-color: rgba(64, 64, 64, 0.4);
}

::-webkit-scrollbar-corner
{
  background-color: rgba(64, 64, 64, 0.4);
}
`;

export default MainLayout;
